import SoftTokensActivateTokenInfoPage from "components/pages/SoftTokensActivateTokenInfoPage";

/**
 * @name CaptureSoftTokenActivationActivateTokenQRCode
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenQRCode(props) {
    return <SoftTokensActivateTokenInfoPage />;
}